import { getSubscriberStatusColor } from "../../../../../services/functions";

import { useSubscribers } from "../../../../../store/subscription/useSubscribers";

import { Container, StatusBadge } from "./styles";

export function SubscriptionDetailsTitle(){
  const details = useSubscribers(st=>st.data.details)
  
  // Verifica se os detalhes estão carregados para evitar erros durante o carregamento
  if (!details) {
    return (
      <Container>Detalhes da Assinatura</Container>
    )
  }

  const background = getSubscriberStatusColor(details.status)

  return (
    <>
      <Container>Detalhes da Assinatura <StatusBadge background={background}>{details.status}</StatusBadge></Container>
    </>
  )
}
